import { useTranslation } from 'react-i18next'
import { PhoneCall } from 'lucide-react'

/** Engineer line as a proposition, not a topbar afterthought (T3.2 §6.1.3). */
const ENGINEER_PHONE_DISPLAY = '+31 299 705 078'
const ENGINEER_PHONE_TEL = '+31299705078'

export default function UrgencyBar() {
  const { t } = useTranslation()
  return (
    <section className="bg-gcg-text text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:justify-between">
        <div>
          <p className="text-lg font-bold">{t('shop.homeV2.urgency.title')}</p>
          <p className="text-sm text-white/70">{t('shop.homeV2.urgency.body')}</p>
        </div>
        <a
          href={`tel:${ENGINEER_PHONE_TEL}`}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white text-base font-semibold rounded-md hover:bg-primary-hover transition-colors shrink-0"
        >
          <PhoneCall className="h-5 w-5" />
          {ENGINEER_PHONE_DISPLAY}
        </a>
      </div>
    </section>
  )
}
